import { render, staticRenderFns } from "./ehc-page.vue?vue&type=template&id=685368a7&scoped=true"
import script from "./ehc-page.vue?vue&type=script&lang=js"
export * from "./ehc-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685368a7",
  null
  
)

export default component.exports